export const SET_LANGUAGE = "set_language";
export const SET_NETWORK = "set_network";



// WEBPACK FOOTER //
// ./frontend/redux/actions/types.js